import moment from 'moment';

function getStatusColorAndLabel(status, statusMetadata) {
  if (status && statusMetadata) {
    const obj = statusMetadata.find(o => o.value === status);
    return [obj.color, obj.label];
  }
  return [status, statusMetadata];
}

function getEstDateTime(date) {
  const estDateTime = new Date(
    date.toLocaleString('en-US', {
      timeZone: 'America/New_York',
    }),
  );
  return estDateTime;
}

function getLocalDateTime(date) {
  const localDate = moment(date, moment.defaultFormat).toDate();
  return localDate;
}

export { getLocalDateTime, getStatusColorAndLabel, getEstDateTime as default };
